import { gql } from '@apollo/client';


export const VALIDATE_USER = gql`query ValidateUser($phone: String!, $mpin: String!) {
  validateUser(phone: $phone, mpin: $mpin)  {
    userId
    phone
    authToken
    created
    message
  }
}
`;
export const SEND_OTP = gql`
query SendOtp($phone: String!) {
  sendOtp(phone: $phone) {
    message
    status
  }
}
`
export const GET_CARS = gql`query GetCars {
  getCars {
    _id
    carModel
    carNumber
    carType
    status
  }
}
`;

export const GET_DRIVERS = gql`query GetDrivers {
getDrivers {
  _id
  userId
  name
  phone
  status
}
}
`;

export const GET_USER_BY_USERID = gql`
query GetUserByUserId($_id: ID!) {
  getUserByUserId(_id: $_id) {
    _id
    name
    phone
    email
    status
    mpin
    totalRides
    userBrand
    userRating
  }
}
`

export const GET_USER_BY_PHONE = gql`
query GetUserByPhone($phone: String!) {
  getUserByPhone(phone: $phone) {
    _id
    name
    phone
    email
    status
    mpin
    totalRides
    userBrand
    userRating
  }
}
`
export const GET_USERDETAILS_BY_USERID = gql`
query GetUserDetailsByUserId($userId: ID!) {
  getUserDetailsByUserId(userId: $userId) {
    _id
    userId
    gstNumber
    billingAddress
    savedAddresses {
      _id
      placeId
      description
      latitude
      longitude
    }
  }
}
`

export const GET_SAVED_ADDRESS_BY_DESCRIPTION = gql`
query GetSaveAddressByDescription($userId: String!, $description: String!) {
  getSaveAddressByDescription(userId: $userId, description: $description) {
    _id
    userId
    gstNumber
    billingAddress
    savedAddresses {
      _id
      placeId
      description
      latitude
      longitude
    }
  }
}
`
export const GET_YESTERDAY_ONWARD_BOOKINGS = gql`
query GetYesterdayOnwardsBookings {
  getYesterdayOnwardsBookings {
    _id
    userId
    name
    passengerName
    bookingId
    phone
    passengerPhone
    createdDate
    bookingDate
    fromCity
    toCity
    fromAddress
    toAddress
    selectedTolls
    totalDistance
    returnRide
    numberOfPassengers
    numberOfBigBags
    carId
    driverId
    referenceId
    corporateId
    couponCode
    ride {
      startTime
      endTime
      rideOtp
      customerRating
      driverRating
      commentByCustomer
      commentByDriver
    }
    payment {
      paymentId
      paymentType
      AdvancePayment
      baseFare
      gstFare
      toll
      parking
      waitingCharges
      extraKmCharges
      totalFare
      extraKms
      waitingTime
      carrierCharges
      extraPickorDrop
      extraPickorDropCharges
      discount
      created
      status
    }
    partnerId
    notification {
      confirmationMsg
      cabDetailsMsg
      driverMsg
    }
    status
  }
}
`;


export const GET_BOOKINGS_BY_USERID = gql`
query GetBookingsByUserId($userId: ID!) {
  getBookingsByUserId(userId: $userId) {
    _id
    userId
    name
    passengerName
    bookingId
    phone
    passengerPhone
    createdDate
    bookingDate
    fromCity
    toCity
    fromAddress
    toAddress
    selectedTolls
    selectedCarModel
    totalDistance
    returnRide
    numberOfPassengers
    numberOfBigBags
    carId
    driverId
    referenceId
    corporateId
    couponCode
    ride {
      startTime
      endTime
      rideOtp
      customerRating
      driverRating
      commentByCustomer
      commentByDriver
    }
    payment {
      paymentId
      paymentType
      AdvancePayment
      baseFare
      gstFare
      toll
      parking
      waitingCharges
      extraKmCharges
      totalFare
      extraKms
      waitingTime
      carrierCharges
      extraPickorDrop
      extraPickorDropCharges
      discount
      created
      status
    }
    partnerId
    notification {
      confirmationMsg
      cabDetailsMsg
      driverMsg
    }
    status
  }
}
`


export const GET_BOOKING_BY_BOOKINGID = gql`
query GetBookingByBookingId($bookingId: String!) {
  getBookingByBookingId(bookingId: $bookingId) {
    _id
    userId
    name
    passengerName
    bookingId
    phone
    passengerPhone
    createdDate
    bookingDate
    fromCity
    toCity
    fromAddress
    toAddress
    selectedTolls
    selectedCarModel
    totalDistance
    returnRide
    numberOfPassengers
    numberOfBigBags
    carId
    driverId
    referenceId
    corporateId
    couponCode
    ride {
      startTime
      endTime
      rideOtp
      customerRating
      driverRating
      commentByCustomer
      commentByDriver
    }
    payment {
      paymentId
      paymentType
      AdvancePayment
      baseFare
      gstFare
      toll
      parking
      waitingCharges
      extraKmCharges
      totalFare
      extraKms
      waitingTime
      carrierCharges
      extraPickorDrop
      extraPickorDropCharges
      discount
      created
      status
    }
    partnerId
    notification {
      confirmationMsg
      cabDetailsMsg
      driverMsg
    }
    status
    paymentOrders
  }
}
`


export const GET_INVOICE_BY_BOOKINGID = gql`
query GetInvoiceByBookingId($bookingId: String!) {
  getInvoiceByBookingId(bookingId: $bookingId) {
    invoiceNumber
    userId
    name
    bookingId
    gstNumber
    billingAddress
    rideStart
    rideEnd
    phone
    fromAddress
    toAddress
    car
    driver
    payment {
      baseFare
      gstFare
      toll
      parking
      totalFare
      waitingCharges
      extraKmCharges
      extraKms
      waitingTime
      carrierCharges
      extraPickorDrop
      extraPickorDropCharges
      discount
    }
    dateIssued
    status
  }
}
`

export const GET_STATIC_COLLECTION = gql`
query GetStaticCollection {
  getStaticCollection {
    name
    value
  }
}
`


export const CALCULATE_FARE = gql`
query CalculateFare($booking: FareCalculationInput) {
  calculateFare(booking: $booking) {
    paymentId
    paymentType
    AdvancePayment
    baseFare
    gstFare
    toll
    parking
    waitingCharges
    extraKmCharges
    totalFare
    extraKms
    waitingTime
    carrierCharges
    extraPickorDrop
    extraPickorDropCharges
    discount
    created
    status
  }
}

`

export const GET_LAST_MINUTE_CARS = gql`
query GetLastMinuteCars {
  getLastMinuteCars {
    _id
    carId
    driverId
    carType
    carRoute
    carLocation
    carTo
    fare
    availableIn
    availabilitySetTime
  }
}
  `

export const GET_ALL_CAR_MODELS = gql`
query GetAllCarModels {
  getAllCarModels {
    _id
    carModel
    carType
    oneWayMumbai
    mumbaiReturn
    lastMinuteFare
    passengerCapacity
    luggageCapacity
    status
    discount {
      lastMinuteBookingDiscount
      onlineBookingDiscount
      firstTimeBookingDiscount
      userBookingDiscount
    }
    fareDetails {
      puneMumbai {
        extraKmCharge
        extraWaitingCharge
        parking
        extraPickDropCharge
        carrierCharge
        initialToll
      }
      rental {
        packages {
          packageId
          includedHr
          includedKm
          price
        }
        extraKmCharge
        extraHrCharge
      }
      outstation {
        outstationOneDayCharge
        outstationExtraKmCharge
        driverAllowance
      }
    }
  }
}

  `


export const SEND_INVOICE_TO_WHATSAPP = gql`
  query SendInvoiceToUserWhatsApp($bookingId: String!) {
    sendInvoiceToUserWhatsApp(bookingId: $bookingId) {
      invoiceNumber
      userId
      name
      bookingId
      gstNumber
      billingAddress
      rideStart
      rideEnd
      selectedTolls
      phone
      fromAddress
      toAddress
      car
      driver
      payment {
        baseFare
        gstFare
        toll
        parking
        totalFare
        waitingCharges
        extraKmCharges
        extraKms
        waitingTime
        carrierCharges
        extraPickorDrop
        extraPickorDropCharges
        discount
      }
      dateIssued
      status
    }
  }`
export const SEND_BOOKINGMSG_USER = gql`
query Query($booking: BookingInput) {
  sendBookingMsgToUser(booking: $booking)
}
  `

export const SEND_BOOKINGMSG_DRIVER = gql`
query Query($booking: BookingInput, $driverId: String) {
  sendBookingMsgToDriver(booking: $booking, driverId: $driverId)
}
  `
export const NEXT_24_HRS_BOOKINGS = gql`
  query GetNext24HourBookings($selectedDate: String) {
    getNext24HourBookings(selectedDate: $selectedDate) {
      _id
      userId
      name
      passengerName
      bookingId
      phone
      passengerPhone
      createdDate
      bookingDate
      fromCity
      toCity
      fromAddress
      toAddress
      selectedTolls
      selectedCarModel
      totalDistance
      returnRide
      numberOfPassengers
      numberOfBigBags
      carId
      driverId
      referenceId
      corporateId
      couponCode
      ride {
        startTime
        endTime
        rideOtp
        customerRating
        driverRating
        commentByCustomer
        commentByDriver
      }
      payment {
        paymentId
        paymentType
        AdvancePayment
        baseFare
        gstFare
        toll
        parking
        waitingCharges
        extraKmCharges
        totalFare
        extraKms
        waitingTime
        carrierCharges
        extraPickorDrop
        extraPickorDropCharges
        discount
        created
        status
      }
      partnerId
      notification {
        confirmationMsg
        cabDetailsMsg
        driverMsg
      }
      status
    }
  }
  `
export const GET_BOOKINGS_BY_PHONE = gql`
  query GetBookingsByPhone($phone: String) {
    getBookingsByPhone(phone: $phone) {
      _id
      userId
      name
      passengerName
      bookingId
      phone
      passengerPhone
      createdDate
      bookingDate
      fromCity
      toCity
      fromAddress
      toAddress
      selectedTolls
      selectedCarModel
      totalDistance
      returnRide
      numberOfPassengers
      numberOfBigBags
      carId
      driverId
      referenceId
      corporateId
      couponCode
      ride {
        startTime
        endTime
        rideOtp
        customerRating
        driverRating
        commentByCustomer
        commentByDriver
      }
      payment {
        paymentId
        paymentType
        AdvancePayment
        baseFare
        gstFare
        toll
        parking
        waitingCharges
        extraKmCharges
        totalFare
        extraKms
        waitingTime
        carrierCharges
        extraPickorDrop
        extraPickorDropCharges
        discount
        created
        status
      }
      partnerId
      notification {
        confirmationMsg
        cabDetailsMsg
        driverMsg
      }
      status
    }
  }
  `

export const GET_RATING_BY_BOOKINGID = gql`
query GetFeedBackRatingByBookingId($bookingId: String!) {
  getFeedBackRatingByBookingId(bookingId: $bookingId) {
    bookingId
    userId
    driverId
    ratingsByDriver {
      punctuality
      respectfulandPolite
      cleanliness
      overallRating
    }
    ratingsByCustomer {
      rashDriver
      onTime
      cleanCar
      overallRating
    }
    feedBackByCustomer
    feedBackByDriver
  }
}`

export const GET_CARMODEL_BY_NAME = gql`
query GetCarModelByName($carModel: String) {
  getCarModelByName(carModel: $carModel) {
    _id
    carModel
    carType
    oneWayMumbai
    mumbaiReturn
    lastMinuteFare
    passengerCapacity
    luggageCapacity
    status
    discount {
      lastMinuteBookingDiscount
      onlineBookingDiscount
      firstTimeBookingDiscount
      userBookingDiscount
    }
    fareDetails {
      puneMumbai {
        extraKmCharge
        extraWaitingCharge
        parking
        extraPickDropCharge
        carrierCharge
        initialToll
      }
      rental {
        extraHrCharge
        extraKmCharge
        packages {
          packageId
          includedHr
          includedKm
          price
        }
      }
      outstation {
        outstationOneDayCharge
        outstationExtraKmCharge
        driverAllowance
      }
    }
  }
}

`